import { render, staticRenderFns } from "./sendEdit.vue?vue&type=template&id=f9833e66&scoped=true&"
import script from "./sendEdit.vue?vue&type=script&lang=js&"
export * from "./sendEdit.vue?vue&type=script&lang=js&"
import style0 from "./sendEdit.vue?vue&type=style&index=0&id=f9833e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9833e66",
  null
  
)

export default component.exports